<ng-template [ngIf]="!legendGroups || legendGroups.length === 0">
	<div class="form-group col-xs-12 col-sm-12 listcheckbox">
		<ng-template ngFor let-item [ngForOf]="checkListOptions" let-i=index>
			<p class='active singlecheckbox col-xs-6 col-sm-4'>
				<input [type]="'checkbox'" id="{{idInput}}_{{item.id}}_{{randomValueString}}"
					[checked]="isChecked(item.id)" (change)="onChange(item.id,$event);" [disabled]='submitPending' />
				<label for='{{idInput}}_{{item.id}}_{{randomValueString}}'>{{item.label}}</label>
			</p>
		</ng-template>
	</div>
</ng-template>

<ng-template [ngIf]="legendGroups && legendGroups.length > 0">
	<ng-template ngFor let-groupLegend [ngForOf]="legendGroups" let-i=index>
		<fieldset class="form-group">
			<legend>{{groupLegend.gruppo}}</legend>
			<div class="form-group col-xs-12 col-sm-12 listcheckbox"
				[ngClass]="(isFs && isCD ) ? 'listcheckbox-flex' : ''"
				[ngStyle]="((isFs && isCD && groupLegend.idGruppo === 'fascicolo') && {'height': '280px'}) || ((isFs && isCD && groupLegend.idGruppo === 'opposizione_servizi_ispettivi') && {'height': '100px'})">
				<p class="active singlecheckbox col-xs-12 col-sm-12  singlecheckbox-flex" *ngIf="groupLegend.idGruppo !== 'metadati'">
					<input [type]="'checkbox'" id="{{idInput}}_allItems_{{groupLegend.idGruppo}}_{{randomValueString}}"
						[checked]="isChecked('allItems')" (change)="onCheckAllItems($event, groupLegend.idGruppo)" />
					<label for='{{idInput}}_allItems_{{groupLegend.idGruppo}}_{{randomValueString}}'>Tutti</label>
				</p>
        <p class="active singlecheckbox col-xs-12 col-sm-12 singlecheckbox-flex" *ngIf="groupLegend.idGruppo === 'metadati'">
					<input [type]="'checkbox'" id="{{idInput}}_allItems_{{groupLegend.idGruppo}}_{{randomValueString}}"
						[checked]="onDisabledUnchecked('allItems','metadati')" (change)="onCheckMaxItems($event, groupLegend.idGruppo)" />
					<label for='{{idInput}}_allItems_{{groupLegend.idGruppo}}_{{randomValueString}}'>{{metadatiLabel}}</label>
				</p>
				<ng-template [ngIf]="groupLegend && groupLegend.sottoGruppi?.length > 0">
					<ng-template ngFor let-sottoGrouppo [ngForOf]="groupLegend.sottoGruppi " let-i=index>
						<div class="col-xs-12 col-sm-12" style="padding-left: 0px;padding-right: 0px;">
							<p class="col-sm-12 sottoGruppo">Campi {{sottoGrouppo.label}} :</p>
							<ng-template ngFor let-item
								[ngForOf]="checkListOptions | itemTenantFilter : sottoGrouppo.idSottoGruppo  : 'idSottoGruppo' : isFs ? 'FS' : 'PRD'"
								let-i=index>
								<p class='active singlecheckbox col-xs-6 col-sm-4'>
									<input [type]="'checkbox'" id="{{idInput}}_{{item.id}}_{{randomValueString}}"
										[checked]="isChecked(item.id)" (change)="onChange(item.id,$event);"
										[disabled]='submitPending' /> <label
										for='{{idInput}}_{{item.id}}_{{randomValueString}}'>{{item.label}}</label>
								</p>
							</ng-template>
						</div>
					</ng-template>
				</ng-template>
				<ng-template ngFor let-item
					[ngForOf]="checkListOptions | itemTenantFilter : groupLegend.idGruppo : 'idGruppo' : isFs ? 'FS' : 'PRD'"
					let-i=index>
					<p *ngIf="!item.idSottoGruppo" class='active singlecheckbox col-xs-6 col-sm-4'>
						<input [type]="'checkbox'" id="{{idInput}}_{{item.id}}_{{randomValueString}}"
							[checked]="isChecked(item.id)" (change)="onChange(item.id,$event);"
							[disabled]='submitPending || onDisabledUnchecked(item.id,item.idGruppo)'/> <label
							for='{{idInput}}_{{item.id}}_{{randomValueString}}'>{{item.label}}</label>
					</p>
				</ng-template>

			</div>
		</fieldset>
	</ng-template>
</ng-template>
